import { AddressBook as AddressBookIcon } from '@phosphor-icons/react/dist/ssr/AddressBook';
import { AlignLeft as AlignLeftIcon } from '@phosphor-icons/react/dist/ssr/AlignLeft';
import { ArrowRight as ArrowRightIcon } from '@phosphor-icons/react/dist/ssr/ArrowRight';
import { Bell as BellIcon } from '@phosphor-icons/react/dist/ssr/Bell';
import { Building as BuildingIcon } from '@phosphor-icons/react/dist/ssr/Building';
import { CalendarCheck as CalendarCheckIcon } from '@phosphor-icons/react/dist/ssr/CalendarCheck';
import { ChartBar as ChartBarIcon } from '@phosphor-icons/react/dist/ssr/ChartBar'
import { ChartLine as ChartLineIcon } from '@phosphor-icons/react/dist/ssr/ChartLine'
import { ChartPie as ChartPieIcon } from '@phosphor-icons/react/dist/ssr/ChartPie';
import { ChatsCircle as ChatsCircleIcon } from '@phosphor-icons/react/dist/ssr/ChatsCircle';
import { City as CityIcon } from '@phosphor-icons/react/dist/ssr/City';
import { CreditCard as CreditCardIcon } from '@phosphor-icons/react/dist/ssr/CreditCard';
import { Cube as CubeIcon } from '@phosphor-icons/react/dist/ssr/Cube';
import { CurrencyEth as CurrencyEthIcon } from '@phosphor-icons/react/dist/ssr/CurrencyEth';
import { Cylinder as CylinderIcon } from '@phosphor-icons/react/dist/ssr/Cylinder';
import { Drop as DropIcon } from '@phosphor-icons/react/dist/ssr/Drop';
import { EnvelopeSimple as EnvelopeSimpleIcon } from '@phosphor-icons/react/dist/ssr/EnvelopeSimple';
import { Fan as FanIcon } from '@phosphor-icons/react/dist/ssr/Fan';
import { File as FileIcon } from '@phosphor-icons/react/dist/ssr/File';
import { FileDashed as FileDashedIcon } from '@phosphor-icons/react/dist/ssr/FileDashed';
import { FileX as FileXIcon } from '@phosphor-icons/react/dist/ssr/FileX';
import { Fire as FireIcon } from '@phosphor-icons/react/dist/ssr/Fire';
import { Gear as GearIcon } from '@phosphor-icons/react/dist/ssr/Gear';
import { GraduationCap as GraduationCapIcon } from '@phosphor-icons/react/dist/ssr/GraduationCap';
import { HardHat as HardHatIcon } from '@phosphor-icons/react/dist/ssr/HardHat';
import { Hourglass as HourglassIcon } from '@phosphor-icons/react/dist/ssr/Hourglass';
import { House as HouseIcon } from '@phosphor-icons/react/dist/ssr/House';
import { Info as InfoIcon } from '@phosphor-icons/react/dist/ssr/Info';
import { Kanban as KanbanIcon } from '@phosphor-icons/react/dist/ssr/Kanban';
import { Leaf as LeafIcon } from '@phosphor-icons/react/dist/ssr/Leaf';
import { Lightning as LightningIcon } from '@phosphor-icons/react/dist/ssr/Lightning'
import { LightningSlash as LightningSlashIcon } from '@phosphor-icons/react/dist/ssr/LightningSlash'
import { Link as LinkIcon } from '@phosphor-icons/react/dist/ssr/Link';
import { ListMagnifyingGlass as ListMagnifyingGlassIcon } from '@phosphor-icons/react/dist/ssr/ListMagnifyingGlass';
import { Lock as LockIcon } from '@phosphor-icons/react/dist/ssr/Lock';
import { MapPin as MapPinIcon } from '@phosphor-icons/react/dist/ssr/MapPin'
import { MapPinArea as MapPinAreaIcon } from '@phosphor-icons/react/dist/ssr/MapPinArea'
import { MapPinSimpleArea as MapPinSimpleAreaIcon } from '@phosphor-icons/react/dist/ssr/MapPinSimpleArea'
import { Notepad as NotepadIcon } from '@phosphor-icons/react/dist/ssr/Notepad'
import { Power as PowerIcon } from '@phosphor-icons/react/dist/ssr/Power'
import { PlugCharging as PlugChargingIcon } from '@phosphor-icons/react/dist/ssr/PlugCharging'
import { Plus as PlusIcon } from '@phosphor-icons/react/dist/ssr/Plus'
import { ReadCvLogo as ReadCvLogoIcon } from '@phosphor-icons/react/dist/ssr/ReadCvLogo';
import { Receipt as ReceiptIcon } from '@phosphor-icons/react/dist/ssr/Receipt';
import { ShareNetwork as ShareNetworkIcon } from '@phosphor-icons/react/dist/ssr/ShareNetwork';
import { ShoppingBagOpen as ShoppingBagOpenIcon } from '@phosphor-icons/react/dist/ssr/ShoppingBagOpen';
import { ShoppingCartSimple as ShoppingCartSimpleIcon } from '@phosphor-icons/react/dist/ssr/ShoppingCartSimple';
import { SignOut as SignOutIcon } from '@phosphor-icons/react/dist/ssr/SignOut';
import { Snowflake as SnowflakeIcon } from '@phosphor-icons/react/dist/ssr/Snowflake';
import { TextAlignLeft as TextAlignLeftIcon } from '@phosphor-icons/react/dist/ssr/TextAlignLeft';
import { ThermometerSimple as ThermometerSimpleIcon } from '@phosphor-icons/react/dist/ssr/ThermometerSimple';
import { Truck as TruckIcon } from '@phosphor-icons/react/dist/ssr/Truck';
import { Upload as UploadIcon } from '@phosphor-icons/react/dist/ssr/Upload';
import { Users as UsersIcon } from '@phosphor-icons/react/dist/ssr/Users';
import { WarningDiamond as WarningDiamondIcon } from '@phosphor-icons/react/dist/ssr/WarningDiamond';
import { Warning as WarningIcon } from '@phosphor-icons/react/dist/ssr/Warning';
import { Wrench as WrenchIcon } from '@phosphor-icons/react/dist/ssr/Wrench';


export const icons = {
  'address-book': AddressBookIcon,
  'align-left': AlignLeftIcon,
  'arrow-right': ArrowRightIcon,

  'bell': BellIcon,
  'building': BuildingIcon,

  'calendar-check': CalendarCheckIcon,
  'chart-bar': ChartBarIcon,
  'chart-line': ChartLineIcon,
  'chart-pie': ChartPieIcon,
  'chats-circle': ChatsCircleIcon,
  'city': CityIcon,
  'credit-card': CreditCardIcon,
  'cube': CubeIcon,
  'currency-eth': CurrencyEthIcon,
  'cylinder': CylinderIcon,

  'drop': DropIcon,

  'envelope-simple': EnvelopeSimpleIcon,

  'fan': FanIcon,
  'file': FileIcon,
  'file-dashed': FileDashedIcon,
  'file-x': FileXIcon,
  'fire': FireIcon,

  'gear': GearIcon,
  'graduation-cap': GraduationCapIcon,

  'hard-hat': HardHatIcon,
  'hourglass': HourglassIcon,
  'house': HouseIcon,

  'info': InfoIcon,

  'kanban': KanbanIcon,

  'leaf': LeafIcon,
  'lightning': LightningIcon,
  'lightning-slash': LightningSlashIcon,
  'link': LinkIcon,
  'list-magnifying-glass': ListMagnifyingGlassIcon,
  'lock': LockIcon,

  'map-pin': MapPinIcon,
  'map-pin-area': MapPinAreaIcon,
  'map-pin-simple-area': MapPinSimpleAreaIcon,

  'notepad': NotepadIcon,

  'plug-charging': PlugChargingIcon,
  'plus': PlusIcon,
  'power': PowerIcon,

  'read-cv-logo': ReadCvLogoIcon,
  'receipt': ReceiptIcon,

  'share-network': ShareNetworkIcon,
  'shopping-bag-open': ShoppingBagOpenIcon,
  'shopping-cart-simple': ShoppingCartSimpleIcon,
  'sign-out': SignOutIcon,
  'snowflake': SnowflakeIcon,

  'text-align-left': TextAlignLeftIcon,
  'thermometer-simple': ThermometerSimpleIcon,
  'truck': TruckIcon,

  'upload': UploadIcon,
  'users': UsersIcon,

  'warning-diamond': WarningDiamondIcon,
  'warning': WarningIcon,
  'wrench': WrenchIcon,
};
